import AgencyIcon from '@cp/src/assets/icons/AgencyIcon';
import AgencyOperationsIcon from '@cp/src/assets/icons/AgencyOperationsIcon';
import AnomalyTrackerIcon from '@cp/src/assets/icons/AnomalyTrackerIcon';
import CsaCoordinationIcon from '@cp/src/assets/icons/CsaCoordinationIcon';
import EnachIcon from '@cp/src/assets/icons/EnachIcon';
import GenerateAmeyoPasswordIcon from '@cp/src/assets/icons/GenerateAmeyoPasswordIcon';
import PDIcon from '@cp/src/assets/icons/PDIcon';
import WhatsappChatIcon from '@cp/src/assets/icons/WhatsappChatIcon';
import AgentsStatusIcon from '@cp/src/assets/images/icons/AgentsStatusIcon';
import AllocationNavbarIcon from '@cp/src/assets/images/icons/AllocationNavbarIcon';
import AvailabilityTrackerIcon from '@cp/src/assets/images/icons/AvailabilityTrackerIcon';
import ReportsIcon from '@cp/src/assets/icons/ReportsIcon';
import CasesIcon from '@cp/src/assets/images/icons/CasesIcon';
import IdCard from '@cp/src/assets/images/icons/IdCard';
import UserManagementActiveIcon from '@cp/src/assets/images/icons/UserManagementActiveIcon';
import UserManagementInactiveIcon from '@cp/src/assets/images/icons/UserManagementInactiveIcon';
import APP_ROUTES, { APP_ROUTES_PATHS_WITH_PATH_PARAM } from '@cp/src/layout/Routes';
import {
  CLICKSTREAM_EVENT_NAMES,
  CLICKSTREAM_EVENT_NAMES_DC,
  ENACH_CLICKSTREAM,
  AGENCY_CAPPING_CLICKSTREAM
} from '@cp/src/service/clickStream.constant';
import { RefreshIcon } from '@navi/web-ui/lib/icons';
import { Roles } from '@cp/src/pages/auth/constants/AuthConstants';
import { FeatureFlags } from '../../sidebar/constants/constants';
import NotificationsCount from '../NotificationsCount/NotificationsCount';
import { IT_TEAM_ROLES_COUNT, requiredRolesForItTeam } from '@cp/src/constants/Common.constants';
import AddressIngestionIcon from '@cp/src/assets/icons/AddressIngestionIcon';
import AddressIngestion from '@cp/src/pages/AddressIngestion';
import CallAuditIcon from '@cp/src/assets/icons/CallAuditIcon';

const SideBarItems = [
  // Cases
  {
    key: APP_ROUTES.CASES.path,
    activeIcon: <CasesIcon />,
    inActiveIcon: <CasesIcon strokeColor="var(--navigation-blue-c2)" />,
    name: 'Cases',
    route: APP_ROUTES.CASES.path,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_CASES_SIDE_PANEL_CLICK,
    isEnabled: {
      excludedFeatureFlags: [FeatureFlags.PERFORMANCE_DASHBOARD],
      excludedRoles: [
        Roles.ROLE_HUMAN_REMINDER_AGENT,
        Roles.ROLE_HUMAN_REMINDER_SPADE_CALLING_AGENT,
        Roles.ROLE_HUMAN_REMINDER_CHAT_AGENT,
        Roles.ROLE_TEAM_LEAD,
        Roles.ROLE_COLLECTION_HEAD,
        Roles.ROLE_SENIOR_TEAM_LEAD,
        Roles.ROLE_GLOBAL_ACCESS
      ],
      roles: [Roles.ROLE_TELE_LITE_AGENT, Roles.ROLE_CALLING_AGENT]
    }
  },
  {
    key: APP_ROUTES.TEAM_LEAD_DASHBOARD.path,
    activeIcon: <CasesIcon />,
    inActiveIcon: <CasesIcon fillColor="var(--navigation-blue-c2)" />,
    name: 'Cases',
    route: APP_ROUTES.TEAM_LEAD_DASHBOARD.path,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_CASES_SIDE_PANEL_CLICK,
    isEnabled: {
      roles: [
        Roles.ROLE_TEAM_LEAD,
        Roles.ROLE_COLLECTION_HEAD,
        Roles.ROLE_SENIOR_TEAM_LEAD,
        Roles.ROLE_GLOBAL_ACCESS
      ],
      customCheck: (userRoles: string[]) =>
        userRoles.length === IT_TEAM_ROLES_COUNT &&
        requiredRolesForItTeam.every(role => userRoles.includes(role))
    }
  },
  // Dashboards
  {
    key: APP_ROUTES.DASHBOARD.path,
    activeIcon: <PDIcon />,
    inActiveIcon: <PDIcon fillColor="var(--navigation-blue-c2)" />,
    name: 'Dashboard',
    route: APP_ROUTES.DASHBOARD.path,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_CALLING_AGENT_DASHBOARD_SIDE_PANEL_CLICK,
    isEnabled: {
      excludedFeatureFlags: [
        FeatureFlags.PERFORMANCE_DASHBOARD,
        FeatureFlags.CSA_DASHBOARD_VISIBLE
      ],
      excludedRoles: [
        Roles.ROLE_HUMAN_REMINDER_AGENT,
        Roles.ROLE_HUMAN_REMINDER_SPADE_CALLING_AGENT,
        Roles.ROLE_HUMAN_REMINDER_CHAT_AGENT,
        Roles.ROLE_TEAM_LEAD,
        Roles.ROLE_COLLECTION_HEAD,
        Roles.ROLE_SENIOR_TEAM_LEAD,
        Roles.ROLE_GLOBAL_ACCESS
      ],
      roles: [Roles.ROLE_TELE_LITE_AGENT, Roles.ROLE_CALLING_AGENT, Roles.ROLE_TELE_CHAT_AGENT]
    }
  },
  {
    key: APP_ROUTES_PATHS_WITH_PATH_PARAM.CSA_DASHBOARD.csa,
    activeIcon: <PDIcon />,
    inActiveIcon: <PDIcon fillColor="var(--navigation-blue-c2)" />,
    name: 'Dashboard',
    route: APP_ROUTES_PATHS_WITH_PATH_PARAM.CSA_DASHBOARD.csa,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_CSA_DASHBOARD_SIDE_PANEL_CLICK,
    isEnabled: {
      featureFlags: [FeatureFlags.CSA_DASHBOARD_VISIBLE]
    }
  },
  {
    key: APP_ROUTES.SENSEI_EXTERNAL.relativePath,
    activeIcon: <PDIcon />,
    inActiveIcon: <PDIcon fillColor="var(--navigation-blue-c2)" />,
    name: 'Dashboard',
    subRoute: '/sensei-external',
    route: APP_ROUTES.SENSEI_EXTERNAL.relativePath,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_AGENT_SENSEI_DASHBOARD_SIDE_PANEL_CLICK,
    isEnabled: {
      requiredFeatureFlags: [
        FeatureFlags.PERFORMANCE_DASHBOARD,
        FeatureFlags.EXTERNAL_AGENCY_PERFORMANCE_DASHBOARD
      ]
    }
  },
  {
    key: APP_ROUTES_PATHS_WITH_PATH_PARAM.SENSEI.daily_planning,
    activeIcon: <PDIcon />,
    inActiveIcon: <PDIcon fillColor="var(--navigation-blue-c2)" />,
    name: 'Dashboard',
    route: APP_ROUTES_PATHS_WITH_PATH_PARAM.SENSEI.daily_planning,
    subRoute: '/sensei',
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_FDM_SENSEI_DASHBOARD_SIDE_PANEL_CLICK,
    isEnabled: {
      featureFlags: [FeatureFlags.PERFORMANCE_DASHBOARD],
      excludedFeatureFlags: [FeatureFlags.EXTERNAL_AGENCY_PERFORMANCE_DASHBOARD]
    }
  },
  {
    key: APP_ROUTES.HR_DASHBOARD.path,
    activeIcon: <PDIcon />,
    inActiveIcon: <PDIcon fillColor="var(--navigation-blue-c2)" />,
    name: 'Performance Dashboard',
    route: APP_ROUTES.SENSEI_TELE.path,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_TELE_SENSEI_SidePanelIconClick,
    isEnabled: {
      featureFlags: [],
      roles: [Roles.ROLE_NAVI_TELE_INHOUSE_TEAM_LEAD]
    }
  },
  // Allocation
  {
    key: APP_ROUTES.ALLOCATION.path,
    activeIcon: <AllocationNavbarIcon />,
    inActiveIcon: <AllocationNavbarIcon />,
    name: 'Allocation',
    route: APP_ROUTES.ALLOCATION.path,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_ALL_AGENTS_SIDE_PANEL_CLICK,
    isEnabled: {
      featureFlags: [],
      roles: [Roles.ROLE_ALLOCATIONS_ACCESS, Roles.ROLE_TELE_ALLOCATIONS_ACCESS]
    }
  },
  // Reports
  {
    key: APP_ROUTES.REPORTS.path,
    activeIcon: <ReportsIcon />,
    inActiveIcon: <ReportsIcon fillColor="var(--navigation-blue-c2)" />,
    name: 'Reports',
    route: APP_ROUTES.REPORTS.path,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_REPORTS_SIDE_PANEL_CLICK,
    isEnabled: {
      featureFlags: [],
      roles: [
        Roles.ROLE_NAVI_FIELD_EXTERNAL_TEAM_LEAD,
        Roles.ROLE_NAVI_TELE_INHOUSE_TEAM_LEAD,
        Roles.ROLE_NAVI_FIELD_TEAM_LEAD,
        Roles.ROLE_NAVI_16_30_FIELD_TEAM_LEAD,
        Roles.ROLE_NAVI_16_30_FIELD_AGENCY_MANAGER,
        Roles.ROLE_NAVI_FIELD_AGENCY_TEAM_LEAD,
        Roles.ROLE_NAVI_30_PLUS_CALLING_TEAM_LEAD
      ]
    }
  },
  // User Management
  {
    key: APP_ROUTES.ALL_AGENTS.path,
    activeIcon: <UserManagementActiveIcon />,
    inActiveIcon: <UserManagementInactiveIcon />,
    name: 'User Management',
    route: APP_ROUTES.ALL_AGENTS.path,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_ALL_AGENTS_SIDE_PANEL_CLICK,
    isEnabled: {
      featureFlags: [],
      roles: [Roles.ROLE_TEAM_LEAD, Roles.ROLE_COLLECTION_HEAD, Roles.ROLE_SENIOR_TEAM_LEAD]
    }
  },
  // Agency Management
  {
    key: APP_ROUTES.AGENCIES.path,
    activeIcon: <AgencyIcon />,
    inActiveIcon: <AgencyIcon fillColor="var(--navigation-blue-c2)" />,
    name: 'Agency Management',
    route: APP_ROUTES.AGENCIES.path,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_AGENCY_MANAGEMENT_SIDE_PANEL_CLICK,
    isEnabled: {
      featureFlags: [FeatureFlags.AGENCY_PAGE_ACCESS],
      roles: []
    }
  },
  // Agency Operations
  {
    key: APP_ROUTES_PATHS_WITH_PATH_PARAM.AGENCY_UTILITIES.agency_pincode_mapping,
    activeIcon: <AgencyOperationsIcon />,
    inActiveIcon: <AgencyOperationsIcon />,
    name: 'Agency Operations',
    route: APP_ROUTES_PATHS_WITH_PATH_PARAM.AGENCY_UTILITIES.agency_pincode_mapping,
    clickStreamEvent: AGENCY_CAPPING_CLICKSTREAM.LH_CLICK_AGENCY_OPERATIONS_TAB,
    isEnabled: {
      featureFlags: [FeatureFlags.AGENCY_CAPPING_ENABLED, FeatureFlags.AGENCY_SERVICEABILITY],
      roles: []
    }
  },
  // Agent Status
  {
    key: APP_ROUTES.LEAVE_MANAGEMENT.path,
    activeIcon: <AgentsStatusIcon />,
    inActiveIcon: <AgentsStatusIcon strokeColor="var(--navigation-blue-c2)" />,
    name: "Agent's Status",
    route: APP_ROUTES.LEAVE_MANAGEMENT.path,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_LEAVE_MANAGEMENT_PAGE_CLICKED,
    isEnabled: {
      featureFlags: [],
      roles: [Roles.ROLE_NAVI_TELE_INHOUSE_TEAM_LEAD]
    }
  },
  // Availability Tracker
  {
    key: APP_ROUTES.AGENT_AVAILABILITY.path,
    activeIcon: <AvailabilityTrackerIcon />,
    inActiveIcon: <AvailabilityTrackerIcon strokeColor="var(--navigation-blue-c2)" />,
    name: 'Availability Tracker',
    route: APP_ROUTES.AGENT_AVAILABILITY.path,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.SIDE_NAV_AGENT_AVAILABILITY_CLICK,
    isEnabled: {
      featureFlags: [],
      roles: [Roles.ROLE_NAVI_TELE_INHOUSE_TEAM_LEAD]
    }
  },
  // Ameyo Utility
  {
    key: APP_ROUTES.AMEYO_UTILITY.path,
    activeIcon: <GenerateAmeyoPasswordIcon />,
    inActiveIcon: <GenerateAmeyoPasswordIcon strokeColor="var(--navigation-blue-c2)" />,
    name: 'Ameyo Utility',
    route: APP_ROUTES.AMEYO_UTILITY.path,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_AMEYO_UTILITY_PAGE_CLICKED,
    isEnabled: {
      featureFlags: [FeatureFlags.IS_AMEYO_UTILITY_VISIBLE],
      roles: []
    }
  },
  // eNACH
  {
    key: APP_ROUTES.ENACH.path,
    activeIcon: <EnachIcon />,
    inActiveIcon: <EnachIcon fillColor="var(--navigation-blue-c2)" />,
    name: 'E-NACH',
    route: APP_ROUTES.ENACH.path,
    clickStreamEvent: ENACH_CLICKSTREAM.LH_SIDEPANEL_ENACH_ICON_CLICKED,
    isEnabled: {
      featureFlags: [FeatureFlags.ENACH_PROCESSING_ENABLED],
      roles: []
    }
  },
  // Approvals
  {
    key: APP_ROUTES.APPROVALS.path,
    activeIcon: <IdCard />,
    inActiveIcon: <IdCard fillColor="var(--navigation-blue-c2)" />,
    name: 'Approvals',
    route: APP_ROUTES.APPROVALS.path,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_CLICKED_ID_APPROVALS,
    isEnabled: {
      featureFlags: [
        FeatureFlags.IS_AGENT_ID_CARD_DETAILS_VISIBLE,
        FeatureFlags.PAN_CARD_APPROVAL_FLOW
      ],
      roles: []
    }
  },
  // Others in alphabetical order
  {
    key: APP_ROUTES_PATHS_WITH_PATH_PARAM.ANOMALY_TRACKER.open,
    activeIcon: <AnomalyTrackerIcon />,
    inActiveIcon: <AnomalyTrackerIcon fillColor="var(--navigation-blue-c2)" />,
    name: 'Anomaly Tracker',
    route: APP_ROUTES_PATHS_WITH_PATH_PARAM.ANOMALY_TRACKER.open,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_ANOMALY_TRACKER_SIDE_PANEL_CLICK,
    isEnabled: {
      featureFlags: [FeatureFlags.ENABLE_ANOMALY_TRACKER],
      roles: []
    }
  },
  {
    key: APP_ROUTES.CSA_COORDINATION.path,
    activeIcon: <CsaCoordinationIcon />,
    inActiveIcon: <CsaCoordinationIcon fillColor="var(--navigation-blue-c2)" />,
    name: 'Field Support',
    route: APP_ROUTES.CSA_COORDINATION.relativePath,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_FIELD_SUPPORT_SIDE_PANEL_CLICK,
    isEnabled: {
      featureFlags: [FeatureFlags.CSA_CO_ORDINATION_MODULE_FEATURE_FLAG],
      roles: []
    }
  },

  {
    key: APP_ROUTES.PARAMOUNT.path,
    activeIcon: <PDIcon />,
    inActiveIcon: <PDIcon fillColor="var(--navigation-blue-c2)" />,
    name: 'Paramount',
    route: APP_ROUTES.PARAMOUNT.path,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_PARAMOUNT_SIDE_PANEL_CLICK,
    isEnabled: {
      featureFlags: [],
      roles: [Roles.ROLE_COLLECTION_CONFIG_READ, Roles.ROLE_COLLECTION_CONFIG_WRITE]
    }
  },
  {
    key: APP_ROUTES.SELF_SERVE_STATE_RESETTER.path,
    activeIcon: <RefreshIcon height={24} width={24} color={'white'} />,
    inActiveIcon: <RefreshIcon height={24} width={24} />,
    name: 'State Resetter',
    route: APP_ROUTES.SELF_SERVE_STATE_RESETTER.path,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_STATE_RESETTER_SIDE_PANEL_CLICK,
    isEnabled: {
      featureFlags: [],
      roles: [Roles.ROLE_TECH_EXCLUSIVE_ACCESS]
    }
  },
  {
    key: APP_ROUTES.TL_GENERATE_AMEYO_PASSWORD.path,
    activeIcon: <GenerateAmeyoPasswordIcon />,
    inActiveIcon: <GenerateAmeyoPasswordIcon strokeColor="var(--navigation-blue-c2)" />,
    name: 'Ameyo Password',
    route: APP_ROUTES.TL_GENERATE_AMEYO_PASSWORD.path,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_TL_GENERATE_AMEYO_PASSWORD_SidePanelIconClick,
    isEnabled: {
      featureFlags: [FeatureFlags.AMEYO_GENERATE_PASSWORD_FLAG],
      excludedFeatureFlags: [FeatureFlags.AMEYO_SELF_SERVE_FLAG],
      roles: []
    }
  },
  {
    key: APP_ROUTES.WHATSAPP_CHATBOT.path,
    activeIcon: <WhatsappChatIcon />,
    inActiveIcon: <WhatsappChatIcon fillColor="var(--navigation-blue-c2)" />,
    name: 'Whatsapp Chatbot',
    route: APP_ROUTES.WHATSAPP_CHATBOT.path,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_WHATSAPP_CHATBOT_CLICK,
    component: <NotificationsCount />,
    isEnabled: {
      featureFlags: [],
      roles: [Roles.ROLE_HUMAN_REMINDER_CHAT_AGENT, Roles.ROLE_TELE_CHAT_AGENT]
    }
  },
  {
    key: APP_ROUTES.ADDRESS_INGESTION.path,
    activeIcon: <AddressIngestionIcon />,
    inActiveIcon: <AddressIngestionIcon />,
    name: 'Address ingestion',
    route: APP_ROUTES.ADDRESS_INGESTION.path,
    component: <AddressIngestion />,
    isEnabled: {
      featureFlags: [FeatureFlags.THIRD_PARTY_ADDRESS_INGESTION],
      roles: []
    }
  },
  {
    key: APP_ROUTES.CALL_AUDIT.path,
    activeIcon: <CallAuditIcon />,
    inActiveIcon: <CallAuditIcon fillColor="var(--navigation-blue-c2)" />,
    name: 'Call Audit',
    route: APP_ROUTES.CALL_AUDIT.path,
    subRoute: '/call-audit',
    activeQueryParam: 'mode*callAudit',
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES_DC.LH_CALL_AUDIT_SIDE_PANEL_CLICK,
    isEnabled: {
      featureFlags: [],
      roles: [Roles.ROLE_PX_AUDIT_AGENT, Roles.ROLE_PX_AUDIT_TEAM_LEAD, Roles.ROLE_CALLING_AGENT]
    }
  }
];

export const persistQueryParamsRoutes = [
  APP_ROUTES_PATHS_WITH_PATH_PARAM.SENSEI.map_view_live_location,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.SENSEI.external_map_view_allocation,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.SENSEI.external_map_view_live_location,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.SENSEI.visit_plan,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.SENSEI.external_visit_plan,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.CSA_COORDINATION.request_field_support,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.CSA_COORDINATION.tasks_for_me,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.ANOMALY_TRACKER.open,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.ANOMALY_TRACKER.closed,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.CSA_DASHBOARD.csa,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.CSA_DASHBOARD.dme
];

export default SideBarItems;
